import { useEffect, useState } from "react";
import { SESSION_EXPIRED_EVENT } from "../Assets/AppConstant";
import "./SessionExpiredModal.css";

const SessionExpiredModal = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handler = () => setOpen(true);
        window.addEventListener(SESSION_EXPIRED_EVENT, handler);

        return () => {
            window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
        };
    }, []);

    const handleOk = () => {
        window.location.href = "/";
    };

    if (!open) return null;

    return (
        <div className="session-overlay">
            <div className="session-modal">
                <h3>Session Expired</h3>
                <p>Your session has expired. Please login again.</p>
                <button className="session-btn" onClick={handleOk}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
